import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux"
import { getPrinters } from "redux/actions/printers/printersActions";
import {
  configPageUsers,
  configSortsUsers,
  configPageSizeUsers,
  configFiltersUsers,
  getUsers,
} from "redux/actions/users/usersActions";

export const useUsersHooks = () => {
  const dispatch = useDispatch()
  
  const handleFilter = useCallback((e) => {
    dispatch( configFiltersUsers(e) )
  }, [])
  const handlePage = useCallback((e) => {
    dispatch( configPageUsers(e) )
  }, [])
  const handlePageSize = useCallback((e) => {
    dispatch( configPageSizeUsers(e) )
  }, [])
  const handleSort = useCallback((e) => {
    dispatch( configSortsUsers(e) )
  }, [])

  
  return {
    handleFilter, handlePage, handlePageSize, handleSort, 
  }
}

export const useBuildUsersLoadings = (users, printers, buildCompLoadings) => {
  const dispatch = useDispatch()

  useEffect(() => {
    users.length === 0 && dispatch( getUsers() );
    buildCompLoadings(['loadingUsers', 'loadingUserEdit', 'loadingNewUser'])
    printers.length === 0 && dispatch( getPrinters() );
   
  }, [])
}